import { useCards } from '../store/cards';
import { useSession } from '../store/session';
import { useUi } from '../store/ui';

const WAIT_MS = 5000;

/**
 * Opens a card from outside the board, a notification or a link: on its own board and in its
 * own column, so closing the sheet leaves the user where the card lives. On a cold start the
 * cards may still be loading; the sheet opens at once and the board follows when they arrive.
 */
export function openCardAnywhere(id: string): void {
  useUi.getState().openSheet(id);
  const place = (): boolean => {
    const card = useCards.getState().cards[id];
    if (!card) return false;
    const session = useSession.getState();
    if (card.boardId !== session.boardId && session.boards.some((b) => b.id === card.boardId)) session.setBoard(card.boardId);
    if (!card.inbox) {
      useUi.getState().setColumn(card.motivation);
      useUi.getState().jumpTo(card.motivation);
    }
    return true;
  };
  if (place()) return;
  const stop = useCards.subscribe(() => {
    if (place()) stop();
  });
  setTimeout(stop, WAIT_MS);
}
